goog.provide("shadow.js.shim.module$intl_tel_input");
goog.provide("module$shadow_js_shim_module$intl_tel_input");
shadow.js.shim.module$intl_tel_input = shadow.js.nativeProvides["intl-tel-input"] = shadow$bridge("intl-tel-input");
module$shadow_js_shim_module$intl_tel_input.default = shadow.js.shim.module$intl_tel_input;
